import React, { FC, useState } from "react";
import Button from "@fv-components/button";

import {
  loginMSALPopup,
  logoutMSALPopup,
  clearMSALCache,
} from "../util-helpers/msal";

import ErrorMsg from "../ErrorMsg";
import { getIsOutlook } from "../util-helpers/office";
import { safeRedirect } from "../util-helpers/common";
import { useAuth } from "../fvid-auth/authContext";

const css = require("./MsalLanding.module.scss");

const MsalLanding: FC = () => {
  const isRefresh = window.location.pathname === "/msalrefresh";
  const isOutlook = getIsOutlook();
  const { resetMSAL } = useAuth();

  const [loginError, setLoginError] = useState("");
  const [cacheCleared, setCacheCleared] = useState(false);

  const onSuccess = () => {
    safeRedirect(window.location.origin);
  };

  const onError = (error: string) => {
    setLoginError(error);
  };

  const handleLoginMSALPopup = () => {
    setLoginError("");
    try {
      loginMSALPopup(onSuccess, onError);
    } catch (error) {
      setLoginError(`${error}`);
    }
  };

  const handleSignOutMSAL = () => {
    setLoginError("");
    try {
      logoutMSALPopup(() => {
        resetMSAL();
      }, onError);
    } catch (error) {
      setLoginError(`${error}`);
    }
  };

  const handleClearCache = () => {
    setLoginError("");
    setCacheCleared(false);
    try {
      clearMSALCache();
      setCacheCleared(true);
    } catch (error) {
      setLoginError(`Failed to clear cache: ${error}`);
    }
  };

  return (
    <>
      <div className={css.loginContainer}>
        <span className={css.message}>
          Filevine’s Office Add-in allows users to
{" "}
          {isOutlook
            ? "send emails, attach emails to a project, and attach Filevine documents to outgoing emails"
            : "save documents, spreadsheets, or presentations directly to Filevine projects"}
          .
        </span>
        <span className={css.message}>
          To do this, we need approval to access your Microsoft account.
        </span>
        {isRefresh && <span>Microsoft Azure AD Session Expired</span>}
        <Button
          raised
          type="submit"
          className={css.loginButton}
          data-test="sign-in"
          onClick={handleLoginMSALPopup}
        >
          {isRefresh ? "Refresh Access" : "Authorize Access"}
        </Button>
        <Button
          type="submit"
          className={css.loginButton}
          data-test="logout-msla"
          onClick={handleSignOutMSAL}
        >
          Sign Out of Microsoft Accounts
        </Button>
        <Button
          type="submit"
          className={css.loginButton}
          data-test="clear-cache"
          onClick={handleClearCache}
        >
          Clear Microsoft Auth Cache
        </Button>
        {cacheCleared && (
          <span className={css.message} style={{ color: "green" }}>
            Cache cleared successfully. Try again by clicking Authorize Access.
          </span>
        )}
        {loginError && <ErrorMsg errorText={loginError} />}
        <Button
          type="submit"
          className={css.loginButton}
          data-test="go-back"
          onClick={() => safeRedirect(window.location.origin)}
        >
          Go back
        </Button>
      </div>
    </>
  );
};

export default MsalLanding;
